import React from 'react';
import { Participant } from '../../types/registration';

interface RemoveDancerConfirmationModalProps {
  dancer: Participant | null;
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isDarkMode?: boolean;
}

/**
 * Modal component to confirm dancer removal from registration
 */
const RemoveDancerConfirmationModal: React.FC<RemoveDancerConfirmationModalProps> = ({
  dancer,
  isOpen,
  onConfirm,
  onCancel,
  isDarkMode = false
}) => {
  if (!isOpen || !dancer) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50" 
        onClick={onCancel}
      ></div>
      
      {/* Modal */}
      <div className={`relative w-full max-w-md p-6 rounded-lg shadow-lg ${
        isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'
      }`}>
        <h3 className="text-lg font-semibold mb-4">Confirm Dancer Removal</h3>
        
        <p className="mb-6">
          Are you sure you want to remove <span className="font-bold">{dancer.firstName} {dancer.lastName}</span> from this registration?
        </p>
        
        {/* Button row */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className={`px-4 py-2 rounded-md ${
              isDarkMode 
                ? 'bg-gray-700 hover:bg-gray-600 text-white' 
                : 'bg-gray-200 hover:bg-gray-300 text-gray-800'
            }`}
          >
            Cancel
          </button>
          
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md"
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveDancerConfirmationModal; 